import type { Role } from '@rabbitfuel/shared';

export interface Session {
  role: Role;
  displayName: string;
  bib?: string;
  /** Notfall-Zugang; der regulaere Weg laeuft ueber das Konto-Token. */
  organizerPin?: string;
}

const key = (slug: string) => `rabbitfuel:session:${slug}`;

export function loadSession(slug: string): Session | null {
  try {
    const raw = sessionStorage.getItem(key(slug));
    return raw ? (JSON.parse(raw) as Session) : null;
  } catch {
    return null;
  }
}

export function saveSession(slug: string, session: Session) {
  try {
    sessionStorage.setItem(key(slug), JSON.stringify(session));
  } catch {
    /* Private Mode o.ae. -- dann eben nur fuer diese Seite. */
  }
}

export function clearSession(slug: string) {
  try {
    sessionStorage.removeItem(key(slug));
  } catch {
    /* egal */
  }
}

export const roleLabel: Record<Role, string> = {
  organizer: 'Veranstalter',
  athlete: 'Athlet:in',
  spectator: 'Zuschauer:in',
};
